import { putObject, getObject } from "@/services/storage/client";

interface ProgressRecord {
  studentId: string;
  completedTopics: string[];
  mistakesByTopic: Record<string, string[]>;
}

/**
 * Memory Engine — writes completion + mistakes to R2 (via the storage
 * service, never fetch() directly) at lesson end, and reads prior
 * mistakes back so the Lesson Engine can bias future checkpoints.
 */
export class MemoryEngine {
  async recordCompletion(studentId: string, sessionId: string, topic: string, mistakes: string[]) {
    await putObject(`history/${sessionId}.json`, { studentId, topic, mistakes });

    const existing = (await getObject<ProgressRecord>(`progress/${studentId}.json`)) ?? {
      studentId,
      completedTopics: [],
      mistakesByTopic: {},
    };

    existing.completedTopics.push(topic);
    existing.mistakesByTopic[topic] = [...(existing.mistakesByTopic[topic] ?? []), ...mistakes];

    await putObject(`progress/${studentId}.json`, existing);
  }

  async getPriorMistakes(studentId: string, topic: string): Promise<string[]> {
    const record = await getObject<ProgressRecord>(`progress/${studentId}.json`);
    return record?.mistakesByTopic?.[topic] ?? [];
  }
}
